<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2e"><a id="page_1"></a><a id="lov"></a><strong>LOVE LETTER TO READERS</strong></h2>
<p class="noindent">Dear Reader,</p>
<p class="noindentt">Just when you think you’ve read every book and heard every conceivable sound byte about out-of-control behaviors, addictions and compulsions, out comes a message and a simple daily process so exhilarating it takes your breath away. You’ve been seeking a new solution, and this is it. There are no coincidences.</p>
<p class="indentt"><em>The Power to Stop</em> is organized and presented in a way that releases you from fears about your out-of-control behavior or your inability to stop yourself. The total absence of fear-based ideas will present a radically different message for most people. We live in a fear-based world where fear is erroneously perceived as correct, useful and godly. Since I do not extend any ideas that engender fear, it’s not reasonable to expect the same old message about stopping that you’ve heard a thousand times before.</p>
<p class="indentt">The process of learning how to stop yourself is also the deeply calming practice of learning how to love yourself. This uncompromising love-based solution makes <em>The Power to Stop</em> a miracle in action. Miracles are possible because the Holy Spirit is present whenever love is extended and received, especially love of self. You are worthy of a healing miracle. You are worthy of self-love and the love of others. You are worthy of goodness. You are worthy of having the life and bodily experience that you envision for yourself.</p>
<p class="indentt"><em>The Power to Stop</em> is the uplifting message that I personally most wanted to hear, but could not find anywhere else except inside myself. It’s with great joy and humble service to the world that I share this song in my heart that <em>must</em> be sung.</p>
<p class="indentt">Love is the only thing that really matters,</p>
<p class="indent"><strong>Karen Bentley</strong></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// readers.vue?2ebf5820